import { useTranslations } from "@/i18n";
import { NavLink } from "react-router-dom";
import { Brand } from "@/components/layout/Brand";
import { authenticatedNavigation } from "@/components/layout/navigation";
import { UserControls } from "@/components/layout/UserControls";
export interface SidebarProps {
  fullName?: string;
  onLogout: () => void;
  username?: string;
}
export function Sidebar({ fullName, onLogout, username }: SidebarProps) {
  const t = useTranslations();
  return (
    <aside className="fixed inset-y-0 left-0 z-50 hidden w-sidebar flex-col overflow-y-auto border-r border-line/80 bg-surface/95 shadow-[8px_0_32px_rgb(28_59_61_/_0.05)] backdrop-blur-xl md:flex">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-accent/[0.08] to-transparent"
      />
      <div className="px-8 py-8">
        <Brand showTagline to="/dashboard" />
      </div>
      <nav
        aria-label={t("common.Sidebar.primaryNavigation")}
        className="relative mt-8 flex-1 space-y-2 px-4"
      >
        {authenticatedNavigation.map(({ icon: Icon, labelId, path }) => (
          <NavLink
            className={({ isActive }) =>
              `relative flex min-h-12 items-center gap-3 rounded-lg px-4 text-sm font-semibold transition-all duration-200 focus:outline-none ${isActive ? "bg-gradient-to-r from-accent/15 to-accent/5 text-ink shadow-sm before:absolute before:-left-4 before:h-8 before:w-1.5 before:rounded-r-full before:bg-highlight" : "text-muted hover:translate-x-0.5 hover:bg-accent/[0.08] hover:text-highlight"}`
            }
            key={path}
            to={path}
          >
            <Icon aria-hidden="true" className="h-[1.125rem] w-[1.125rem]" />
            {t(labelId)}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-line p-4">
        <UserControls fullName={fullName} onLogout={onLogout} username={username} />
      </div>
    </aside>
  );
}
